import { CommonModule } from '@angular/common';
import { inject, input, signal } from '@angular/core';
import { UtilsService } from 'Angular/services/core/utils.service';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = a0 => ({ "fade-out": a0 });
function AgentMessageCopyButtonComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 8);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 9)(4, "div", 10);
    i0.ɵɵtext(5, "Copied to clipboard");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r0.fadeOutAlert()));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
export class AgentMessageCopyButtonComponent {
    constructor() {
        this.utilsService = inject(UtilsService);
        this.contentElement = input.required(...(ngDevMode ? [{ debugName: "contentElement" }] : []));
        this.showAlert = signal(false, ...(ngDevMode ? [{ debugName: "showAlert" }] : []));
        this.fadeOutAlert = signal(false, ...(ngDevMode ? [{ debugName: "fadeOutAlert" }] : []));
    }
    copyAIResponse() {
        const element = this.contentElement();
        if (element) {
            const contentCopied = this.utilsService.copyToClipboard(element.textContent || '');
            if (contentCopied && !this.showAlert()) {
                this.showAlert.set(true);
                setTimeout(() => {
                    this.fadeOutAlert.set(true);
                }, 1000);
                setTimeout(() => {
                    this.showAlert.set(false);
                    this.fadeOutAlert.set(false);
                }, 1300);
            }
        }
    }
}
AgentMessageCopyButtonComponent.ɵfac = function AgentMessageCopyButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentMessageCopyButtonComponent)(); };
AgentMessageCopyButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentMessageCopyButtonComponent, selectors: [["ycn-agent-message-copy-button"]], inputs: { contentElement: [1, "contentElement"] }, decls: 7, vars: 2, consts: [[1, "section-ai-response-footer"], [1, "text-center", 3, "ngClass"], [1, "section-ai-feedback", "mb-2", "ng-scope"], [1, "mb-2"], [1, "d-flex", 2, "margin-bottom", "10px"], ["ycnTooltip", "", "tooltipTitle", "Copy to clipboard", 1, "btn", "btn-transparent2", "btn-circle", 3, "click", "tooltipPlacement"], ["ycnIcon", "", "name", "icon-report", "role", "img", 1, "icon-report"], [1, "toast", "toast-success"], ["ycnIcon", "", "role", "img", 1, "mr-1", "fill-current", 3, "name"], [1, "toast-text"], [1, "text-bold"]], template: function AgentMessageCopyButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵconditionalCreate(1, AgentMessageCopyButtonComponent_Conditional_1_Template, 6, 4, "div", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "button", 5);
        i0.ɵɵlistener("click", function AgentMessageCopyButtonComponent_Template_button_click_5_listener() { return ctx.copyAIResponse(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 6);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showAlert() ? 1 : -1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("tooltipPlacement", "top");
    } }, dependencies: [CommonModule, i1.NgClass, IconModule, i2.IconDirective, TooltipModule, i3.TooltipDirective], encapsulation: 2, changeDetection: 0 });
